import Logger from "../lib/logger";

const accessKey = "f3287ae9e3cbb4c36c2cfff6b8b9fe28";
const ip = 'check';
const IP_COUNTRY = 'ip_country';
const MUSE_LOCATION = 'muse_location';
/* const STORES = ['ca', 'eu', 'intl', 'us']; */
const EU_LOCATIONS = ['UK', 'FR', 'ES', 'DE'];
const INTL_LOCATIONS = ['AU', 'TH', 'AR', 'CL', 'IL', 'AE', 'JP', 'SG', 'NZ', 'IN'];


class Location {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	static NAME = 'Location';

	static modal = document.querySelector('[data-theme-redirect-modal]');
	static overlay = document.querySelector('.theme-redirect-modal__overlay');
	static overrideButton = this.modal.querySelector('button');
	static modalActiveClass = 'theme-redirect-modal--active';

	/**
	 * Attempt to enforce access to users in Canada only
	 **/
	static async checkCountry() {

		Logger.info(`${this.NAME} > checkCountry`);

		// Check to see if we have already checked
		const ipCountry = localStorage.getItem(IP_COUNTRY);
		const museLocation = localStorage.getItem(MUSE_LOCATION);
		const cookie = Location.getCookie('_muse_store');
		console.log('ipCountry', ipCountry, 'cookie', cookie, 'museLocation', museLocation);

		// Stop if user is in correct store;
		if (ipCountry && (ipCountry.toLocaleLowerCase() === cookie || museLocation === cookie)) {
			Logger.info(`${this.NAME} > checkCountry > User is in ${ipCountry} and in ${cookie.toUpperCase()} Store`);
			return;
		}

		// We don't know where the user is. Let's try to find out

		// set endpoint and your access key
		const url = 'http://api.ipstack.com/' + ip + '?access_key=' + accessKey;

		const response = await fetch(url, {
			method: 'POST',
			headers: {
				// 'Content-Type': 'application/json',
				// 'Access-Control-Allow-Headers': '*', // this will allow all CORS requests
			}
		});

		const responseJson = await response.json();
		/* console.log(responseJson); */

		// Save the user's country for later
		const countryCode = responseJson.country_code;
		const eu = EU_LOCATIONS.find(val => val === countryCode);
		const intl = INTL_LOCATIONS.find(val => val === countryCode);
		if (countryCode) {
			localStorage.setItem(IP_COUNTRY, countryCode);
			/* if (eu) localStorage.setItem(MUSE_LOCATION, 'eu');
			if (intl) localStorage.setItem(MUSE_LOCATION, 'intl'); */
		}

		// If the user is not in the right store show country select modal
		if ((countryCode && countryCode.toLowerCase() != cookie) || (eu && cookie !== 'eu') || (intl && cookie !== 'intl')) {
			Logger.info(`${this.NAME} > checkCountry > User is in ${countryCode}... show modal`);
			Location.handleWrongUserLocation();
			return;
		}

	}

	/**
	 * Handle a user in wrong store, show country select modal
	 **/
	static handleWrongUserLocation() {
		Logger.info(`${this.NAME} > handleWrongUserLocation`);
		this.modal.classList.add(this.modalActiveClass);
		this.overlay.classList.add('theme-redirect-modal__overlay--active');
		document.querySelector('body').classList.add('modal--active');
		document.querySelector('html').classList.add('modal--active');
	}

	/**
	 * Handle a button override
	 **/
	/* static handleOverride() {
		this.modal.classList.remove(this.modalActiveClass);
		document.querySelector('body').classList.remove('modal--active');
		document.querySelector('html').classList.remove('modal--active');
	} */

	static getCookie(name) {
		let matches = document.cookie.match(new RegExp(
		  "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));
		return matches ? matches[1] : false;
	}

	/**
	 * Class static initialization block
	 */
	static {
		Logger.info(`${this.NAME} > init`);
	}
}

export default Location;
